exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".excel-layout-header-bar{display:-ms-flexbox;display:flex}.excel-layout-header-bar .actions-button,.excel-layout-header-bar .excel-layouts-dropdown{margin-right:10px}.excel-layout-header-bar .tooltip-body button{white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/shared/components/excel-layout/excel-layout-header-bar/index.scss
// module id = 5247
// module chunks = 0